import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css'; // Make sure this line is here
import App from './App'; // This will now point to App.jsx
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();